const config = {
  Auth: {
    region: 'ap-southeast-1',
    userPoolId: 'ap-southeast-1_4rwIIHosV',
    userPoolWebClientId: '3jkcug34c9r2l060p1oscue4fv',
  },
};

export default config;
